import React from "react";
import { useContext } from "react";
import { Card, ListGroup } from "react-bootstrap";
import { serverInfo } from "../../App";
// import demo from "../../../../../assets/images/pendingIcons/demo.png";
import demo from "../../assets/images/pendingIcons/demo.png";

function JuryJudgeListItem({ data, type = null }) {
  const { imageCdnUrl } = useContext(serverInfo);
  return (
    <>
      {type === "admin" ? (
        <ListGroup.Item className="d-flex juryItem justify-content-center">
          <img
            className="demoStar"
            src={
              data.admin?.image != null
                ? imageCdnUrl+data.admin?.image
                : demo
            }
            alt=""
          />
          <div className="mx-2">
            <h6 className="text-light">
              {data.admin?.first_name} {data.admin?.last_name}
            </h6>
            <p className="text-light">{data.admin?.category?.name}</p>
          </div>
        </ListGroup.Item>
      ) : (
        <ListGroup.Item className="d-flex juryItem justify-content-center">
          <img
            className="demoStar"
            src={
              data.user?.image != null
                ? imageCdnUrl+data.user?.image
                : demo
            }
            alt=""
          />
          <div className="mx-2">
            <h6 className="text-light">
              {data.user?.first_name} {data.user?.last_name}
            </h6>
            <p className="text-light">{data.user?.category?.name}</p>
          </div>
        </ListGroup.Item>
      )}
    </>
  );
}

export default JuryJudgeListItem;
